import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from '~shared/components/modal/modal.module';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  // `title` ET `id` sont des entrées écrites en attributs statiques
  // (`title="MODAL.…"`, `id="detail-…"`) : sans ces bindings, Angular les
  // laisserait AUSSI sur l'hôte `app-confirm-modal`. Pour `title`, c'était la
  // clé i18n brute en infobulle de toute la modale. Pour `id`, c'était un
  // DOUBLON (RGAA 8.2) : l'`id` reste nécessaire sur l'hôte réel, le
  // `app-jw-modal` que ce composant déplace sous `<body>` ; le garder aussi sur
  // l'emballage laissé en place donnait deux éléments pour un même identifiant.
  host: { '[attr.title]': 'null', '[attr.id]': 'null' },
  imports: [CommonModule, TranslateModule, ModalModule],
  template: `
    <app-jw-modal
      [id]="id"
      [title]="title"
      [class]="bodyClass"
      (cancelAct)="cancelAct.emit()"
    >
      <ng-content></ng-content>
      <div class="modal-actions dflex jcsb">
        <button
          [attr.id]="id + '-cancel'"
          class="hub-button hub-button--large hub-button--ghost"
          (click)="cancelAct.emit()"
        >
          {{ cancelLabel | translate }}
        </button>
        @if (showConfirm) {
          <button
            [attr.id]="id + '-confirm'"
            class="hub-button hub-button--large"
            [class.hub-button--danger]="danger"
            (click)="confirmAct.emit()"
          >
            {{ confirmLabel | translate }}
          </button>
        }
      </div>
    </app-jw-modal>
  `,
})
export class ConfirmModalComponent {
  @Input({ required: true }) id!: string;
  @Input() title = '';
  @Input() bodyClass = '';
  @Input() danger = false;
  @Input() cancelLabel = 'BUTTON.CANCEL';
  @Input() confirmLabel = 'GLOBAL.DELETE';
  /**
   * Masque l'action de confirmation (la modale devient purement informative,
   * seul « Annuler » reste) — ex. « Modifier » de la modale « Voir plus »
   * quand l'utilisateur n'a pas le droit update sur la fiche (869ehtvet).
   */
  @Input() showConfirm = true;
  @Output() confirmAct = new EventEmitter<void>();
  @Output() cancelAct = new EventEmitter<void>();
}
